import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formActions from 'actions/formActions';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import RadioField from './../RadioField';
import styles from './TicketingQuestionsFieldset.scss';
import {change, formValues} from 'redux-form';

const TicketingQuestionsFieldset = formValues({
  pricingType: 'pricing_type',
  ticketsRequired: 'tickets_required',
  ticketingType: 'ticketing_url_type',
  prices: 'prices',
})(({ formErrors, ticketsRequired }) => {
  return(<div className={styles.TicketingQuestionsFieldset}>
    <div className="row">
      <div className="col">
        <FormField
          label="Does your event require tickets?"
          name="tickets_required"
          component={RadioField}
          error={formErrors.get('tickets_required')}
          data={[
            {text: 'Yes', value: 'yes'},
            {text: 'No', value: 'no' },
          ]}
          type="text"
          className="form-control"
          required
        />
      </div>
    </div>
    {ticketsRequired === 'yes' && <div className="row">
      <div className="col">
        <FormField
          label="Type of ticket"
          name="pricing_type"
          component={RadioField}
          error={formErrors.get('pricing_type')}
          data={[
            {text: 'Paid', value: 'tickets_in_advance'},
            {text: 'Free', value: 'registration_required'},
          ]}
          type="text"
          className="form-control"
          required
        />
      </div>
    </div>}
  </div>);
});


const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(formActions, dispatch),
  ...bindActionCreators({ change }, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(TicketingQuestionsFieldset);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/TicketingQuestionsFieldset.jsx